import { tryCatchSync } from './common';

export function nodeAtob(string: string) {
  const { data, error } = tryCatchSync(() => Buffer.from(string, 'base64').toString('binary'));
  if (error) {
    console.error('Error decoding base64 string:', error);
    return '';
  }
  return data;
}

export function nodeBtoa(string: string) {
  const { data, error } = tryCatchSync(() => Buffer.from(string, 'binary').toString('base64'));
  if (error) {
    console.error('Error encoding string to base64:', error);
    return '';
  }
  return data;
}
